module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_phone-1f00dda7f760a92a8e249737f7465db6.svg";